import { translate } from 'core/locales';
import { I18nextProvider } from 'react-i18next';

export { useTranslation } from 'react-i18next';

export const LocalizationProvider = ({ children }) => {
    return <I18nextProvider i18n={translate}>{children}</I18nextProvider>;
};
